import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotFound from "../modules/admin/NotFound";
import WorkProfile from "src/business-types/grocery/layouts/profile/WorkProfile";
import ProfileTheme from "src/business-types/grocery/layouts/profile/ProfileTheme";
import ProfileMenu from "src/business-types/grocery/layouts/profile/ProfileMenu";
import { ThemeBasedColorMenubar } from "../modules/profile/theme/themeCheacker";
import GroceryConfigration from "./GroceryConfigration";
import { UserDetails } from "../context/contextInterface";

type Props = {
  user: UserDetails;
  prodileId?: any;
};

function GroceryProfile({ user, prodileId }: Props) {
  return (
    <div className='w-full h-full flex flex-col overflow-hidden'>
      <ProfileMenu />
      <div className={`w-auto h-[87%] flex my-1 mr-5 mx-2 border border-gray-200 rounded-2xl  shadow-inner ${ThemeBasedColorMenubar()}`}>
        <Routes>
          {/* Default Redirect */}
          <Route path='/' element={<Navigate to='work-profile' />} />

          {/* Work Profile */}
          <Route path='work-profile' element={<WorkProfile user={user} prodileId={prodileId} />} />

          {/* Theme */}
          <Route path='theme' element={<ProfileTheme />} />
          <Route path='/configuration/*' element={<GroceryConfigration />} />

          {/* 404 */}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
}

export default GroceryProfile;
